import type { SVGProps } from 'react'
const SvgVerticalEllipsis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="4"
    height="14"
    viewBox="0 0 4 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 10.5C1.46957 10.5 0.96086 10.6844 0.585787 11.0126C0.210714 11.3408 0 11.7859 0 12.25C0 12.7141 0.210714 13.1592 0.585787 13.4874C0.96086 13.8156 1.46957 14 2 14C2.53043 14 3.03914 13.8156 3.41421 13.4874C3.78929 13.1592 4 12.7141 4 12.25C4 11.7859 3.78929 11.3408 3.41421 11.0126C3.03914 10.6844 2.53043 10.5 2 10.5ZM2 5.25C1.46957 5.25 0.96086 5.43437 0.585787 5.76256C0.210714 6.09075 0 6.53587 0 7C0 7.46413 0.210714 7.90925 0.585787 8.23744C0.96086 8.56563 1.46957 8.75 2 8.75C2.53043 8.75 3.03914 8.56563 3.41421 8.23744C3.78929 7.90925 4 7.46413 4 7C4 6.53587 3.78929 6.09075 3.41421 5.76256C3.03914 5.43437 2.53043 5.25 2 5.25ZM2 0C1.46957 0 0.96086 0.184374 0.585787 0.512563C0.210714 0.840752 0 1.28587 0 1.75C0 2.21413 0.210714 2.65925 0.585787 2.98744C0.96086 3.31563 1.46957 3.5 2 3.5C2.53043 3.5 3.03914 3.31563 3.41421 2.98744C3.78929 2.65925 4 2.21413 4 1.75C4 1.28587 3.78929 0.840752 3.41421 0.512563C3.03914 0.184374 2.53043 0 2 0Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgVerticalEllipsis
